import Index from './index'

export default {
  path: '/recruiting/:policyType(TOS|PRIVACY)',
  component: Index,
  meta: {
    noAuth: true,
    policyType: 'PRIVACY'
  }
}
